import { gql } from '@moonpig/web-core-graphql'

const DispatchCutOffFragment = {
  fields: gql`
    fragment DispatchCutOffFields on ContentDepartment {
      dispatchCutOff {
        weekdays {
          message
          time
        }
        weekendsAndBankHolidays {
          message
          time
        }
      }
    }
  `,
}

export const GetDepartmentInfoGQL = gql`
  query GetDepartmentInfo($filter: [ID!], $preview: Boolean) {
    contentDepartments(filter: $filter, preview: $preview) {
      id
      promotionBanner
      longDeliveryInfo
      ...DispatchCutOffFields
      subdepartments {
        id
        promotionBanner
        longDeliveryInfo
        ...DispatchCutOffFields
      }
    }
  }
  ${DispatchCutOffFragment.fields}
`
